module.exports = __webpack_public_path__ + "static/media/hamburger.78d5728f.svg";